import React from 'react';
import { Link } from 'react-router-dom';
import { HardHatIcon, PackageIcon, TruckIcon, FactoryIcon, ArrowRightIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function Applications() {
  const {
    lang
  } = useTranslation();
  const applications = lang === 'en' ? [{
    icon: HardHatIcon,
    title: 'Construction sites',
    problem: 'Carrying heavy materials up stairs wastes time and endangers worker safety.',
    solution: 'Transport up to 250kg safely and efficiently, reducing injuries and improving productivity.'
  }, {
    icon: PackageIcon,
    title: 'Warehousing',
    problem: 'Multi-story facilities require constant movement of goods between floors.',
    solution: 'Streamline vertical logistics with reliable stair-climbing technology.'
  }, {
    icon: TruckIcon,
    title: 'Delivery services',
    problem: 'Last-mile delivery to upper floors is physically demanding and time-consuming.',
    solution: 'Enable single-person delivery operations with equipment that effortlessly climbs stairs.'
  }, {
    icon: FactoryIcon,
    title: 'Manufacturing',
    problem: 'Moving materials between production levels creates bottlenecks.',
    solution: 'Maintain smooth production flow with industrial solutions for continuous operation.'
  }] : [{
    icon: HardHatIcon,
    title: 'Građevinski objekti',
    problem: 'Prenošenje teških materijala uz stepenice gubi vreme i ugrožava bezbednost radnika.',
    solution: 'Transportujte do 250kg bezbedno i efikasno, smanjujući povrede i poboljšavajući produktivnost.'
  }, {
    icon: PackageIcon,
    title: 'Skladištenje',
    problem: 'Višespratni objekti zahtevaju stalno kretanje robe između spratova.',
    solution: 'Pojednostavite vertikalnu logistiku sa pouzdanom tehnologijom penjanja stepenicama.'
  }, {
    icon: TruckIcon,
    title: 'Usluge dostave',
    problem: 'Dostava na poslednjoj milji do gornjih spratova je fizički zahtevna i dugotrajna.',
    solution: 'Omogućite operacije dostave sa jednom osobom uz opremu koja se bez napora penje stepenicama.'
  }, {
    icon: FactoryIcon,
    title: 'Proizvodnja',
    problem: 'Premeštanje materijala između proizvodnih nivoa stvara uska grla.',
    solution: 'Održavajte nesmetan tok proizvodnje sa industrijskim rešenjima za kontinualan rad.'
  }];
  return <section className="py-20 bg-dark-bg" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-130">
            <span className="text-brand-yellow" data-id="element-131">
              {lang === 'en' ? 'Applications' : 'Primene'}
            </span>{' '}
            {lang === 'en' ? 'across industries' : 'u različitim industrijama'}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-132">
            {lang === 'en' ? 'From construction to logistics, D-TECH Solutions solves real problems for businesses that need reliable vertical transport.' : 'Od građevinarstva do logistike, D-TECH Solutions rešava realne probleme za preduzeća kojima je potreban pouzdan vertikalni transport.'}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-133">
          {applications.map(app => {
          const Icon = app.icon;
          return <Card key={app.title} hover data-id="element-134">
                <div className="flex items-start space-x-4" data-id="element-135">
                  <div className="w-12 h-12 bg-brand-yellow rounded-industrial flex items-center justify-center flex-shrink-0" data-id="element-136">
                    <Icon className="w-6 h-6 text-dark-bg" data-id="element-137" />
                  </div>
                  <div className="flex-1" data-id="element-138">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-139">
                      {app.title}
                    </h3>
                    <p className="text-sm text-gray-400 mb-2" data-id="element-140">
                      <span className="font-semibold text-gray-300" data-id="element-141">
                        {lang === 'en' ? 'Problem:' : 'Problem:'}
                      </span>{' '}
                      {app.problem}
                    </p>
                    <p className="text-sm text-gray-300" data-id="element-142">
                      <span className="font-semibold text-brand-yellow" data-id="element-143">
                        {lang === 'en' ? 'Solution:' : 'Rešenje:'}
                      </span>{' '}
                      {app.solution}
                    </p>
                  </div>
                </div>
              </Card>;
        })}
        </div>
        <div className="text-center" data-id="element-144">
          <Link to="/applications" data-id="element-145">
            <Button variant="secondary" size="lg" data-id="element-146">
              {lang === 'en' ? 'View all applications' : 'Pogledajte sve primene'}
              <ArrowRightIcon className="w-5 h-5 ml-2 inline" data-id="element-147" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}